import React, { useEffect, useRef, useState } from 'react';
import css from './LandingPage.css';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import searchIcon from '../../assets/searcIcon.png';

const datas = [
  {
    question: <FormattedMessage id="LandingPage.SectionHelp.questionAnswer.one.question" />,
    answer: <FormattedMessage id="LandingPage.SectionHelp.questionAnswer.one.answer" />,
  },
  {
    question: <FormattedMessage id="LandingPage.SectionHelp.questionAnswer.two.question" />,
    answer: <FormattedMessage id="LandingPage.SectionHelp.questionAnswer.two.answer" values={{
      TM: <sup>TM</sup>
    }}/>,
  },
  {
    question: <FormattedMessage id="LandingPage.SectionHelp.questionAnswer.three.question" />,
    answer: <FormattedMessage id="LandingPage.SectionHelp.questionAnswer.three.answer" />,
  },
  {
    question: <FormattedMessage id="LandingPage.SectionHelp.questionAnswer.four.question" />,
    answer: <FormattedMessage id="LandingPage.SectionHelp.questionAnswer.four.answer" />,
  },
];

const QuestionAnswer = ({ question, answer, onClick, showAnswer, ...rest }) => {
  return (
    <div className={css.questionAnswer} {...rest}>
      <div className={css.question} onClick={onClick}>
        {question}
      </div>
      <div
        className={classNames(css.answer, {
          [css.showAnswer]: showAnswer,
        })}
      >
        {answer}
      </div>
    </div>
  );
};

const SectionHelp = ({ data }) => {
  const [openQuestion, setOpenQuestion] = useState(null);
  const inputRef = useRef(null);

  const handleClickQuestion = i => {
    if (openQuestion === i) setOpenQuestion(null);
    else setOpenQuestion(i);
  };

  useEffect(() => {
    inputRef.current.addEventListener('keyup', e => {
      if (e.keyCode === 13) {
        window.open(`https://help.drivelah.sg/en/?q=${e.target.value}`);
      }
    });
  }, []);

  return (
    <div className={css.sectionHelp}>
      <div className={css.sectionHelpTitle}>
        <FormattedMessage id="LandingPage.SectionHelp.title" />
      </div>
      <div className={css.searchHelp}>
        <img src={searchIcon} className={css.searchIcon} />
        <input
          className={css.searchHelpInput}
          placeholder="Eg, Who can be a host?"
          ref={inputRef}
        />
      </div>
      <div className={css.helpQuestions}>
        {(data || datas).map((d, index) => (
          <QuestionAnswer
            {...d}
            key={index}
            index={index}
            showAnswer={openQuestion === index}
            onClick={() => handleClickQuestion(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default SectionHelp;
